<template>
  <v-dialog
    v-model="dialogCadastroPregao"
    persistent
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        fab
        dark
        large
        class="mx-2"
        elevation="4"
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon large>add_chart</v-icon>
      </v-btn>
    </template>
    <template>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Cadastrar Pregão</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn class="mx-2" icon>
              <v-icon dark large @click="fecharModal">cancel</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <cadastroPregao
            v-if="dialogCadastroPregao"
            :orgaosCadastrados="orgaosCadastrados"
            :produtosCadastrados="produtosCadastrados"
            @fechar="fecharModal"
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="fecharModal">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import axios from "axios";
import cadastroPregao from "./cadastroPregao";
import { urlApi, showError } from "@/global";

export default {
  name: "modalCadastroPregao",
  components: { cadastroPregao },

  data: function() {
    return {
      dialogCadastroPregao: false,
      orgaosCadastrados: [],
      produtosCadastrados: [],
    };
  },

  watch: {
    dialogCadastroPregao(val) {
      if (val) {
        this.carregarOpcoes();
      }
    },
  },

  methods: {
    carregarOpcoes() {
      this.getOrgao();
      this.getProduto();
    },

    fecharModal() {
      this.dialogCadastroPregao = false;
    },

    getOrgao() {
      axios
        .get(`${urlApi}/orgao`)
        .then((res) => {
          this.orgaosCadastrados = res.data.map((orgao) => orgao.nomeOrgao);
        })
        .catch(showError);
    },

    getProduto() {
      axios
        .get(`${urlApi}/produto`)
        .then((res) => {
          this.produtosCadastrados = res.data;
        })
        .catch(showError);
    },
  },
};
</script>

<style>
</style>
